import Vue from "vue";

export default {
  async fetchPrjData({ commit }, pvId) {
    Vue.$log.debug("loading dpr header for", pvId);
    return Vue.axios.get(Vue.$url("prj-search/" + pvId)).then((rsp) => {
      commit("SET_PRJ_DATE", rsp.data);
      return rsp.data;
    });
  },
};
